import { parseHtml } from '@grandvisionhq/lib-utils-html';
import { isDefined } from '@grandvisionhq/utils';
import '@swc/helpers';
import 'react';
import { useBrPageContext, useBrComponentContext } from '../context/context.js';
import '@bloomreach/react-sdk';
import '../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import { getBrPageContent } from '../utils/get-br-page-content.js';
import '@grandvisionhq/common';
import '../utils/http-client.js';

const useBloomreachGroupCardsData = ()=>{
    var ref;
    const page = useBrPageContext();
    const component = useBrComponentContext();
    if (!component || !page) return undefined;
    const { pageable  } = component.getModels();
    const params = component.getParameters();
    const cards = pageable === null || pageable === void 0 ? void 0 : (ref = pageable.items) === null || ref === void 0 ? void 0 : ref.map((item)=>{
        const cardContent = getBrPageContent(page, item);
        if (!cardContent) return undefined;
        const { content , link , title , card_image  } = cardContent;
        return {
            content: (content === null || content === void 0 ? void 0 : content.value) ? parseHtml(content.value) : '',
            urlText: link === null || link === void 0 ? void 0 : link.label,
            url: link === null || link === void 0 ? void 0 : link.url,
            header: title || '',
            icon: card_image || ''
        };
    }).filter(isDefined);
    return {
        cards,
        title: params.title
    };
};

export { useBloomreachGroupCardsData };
//# sourceMappingURL=use-bloomreach-group-cards-data.js.map
